var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "detailForm",
          staticClass: "demo-detailForm",
          attrs: {
            model: _vm.detailForm,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "版本", prop: "version" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.isForbidden },
                model: {
                  value: _vm.detailForm.version,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "version", $$v)
                  },
                  expression: "detailForm.version",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "类型", prop: "type" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.isForbidden,
                    clearable: "",
                    placeholder: "请选择类型",
                  },
                  model: {
                    value: _vm.detailForm.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "type", $$v)
                    },
                    expression: "detailForm.type",
                  },
                },
                _vm._l(_vm.typeOptions, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "启用", prop: "enable" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.isForbidden,
                    placeholder: "请选择状态",
                    clearable: "",
                  },
                  model: {
                    value: _vm.detailForm.enable,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "enable", $$v)
                    },
                    expression: "detailForm.enable",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "是", value: true } }),
                  _c("el-option", { attrs: { label: "否", value: false } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "生效时间", prop: "effectiveDate" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  disabled: _vm.isForbidden,
                  clearable: "",
                  "value-format": "yyyy-MM-dd",
                  type: "date",
                  placeholder: "选择日期",
                },
                model: {
                  value: _vm.detailForm.effectiveDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "effectiveDate", $$v)
                  },
                  expression: "detailForm.effectiveDate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          !_vm.isForbidden
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.onSave("detailForm")
                    },
                  },
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }